import store from 'store2';
import constants from './constants';

/*
 * 「Surveyへの回答を拒否した」という状態をLocalStorageに保存する
 *
 * @param {number} keepDays - 保存する日数
 */
const declineSurvey = keepDays => {
  store(constants.SURVEY_STATE_NAME, constants.SURVEY_STATE_VALUE_DECLINED);
  if (keepDays < 0) {
    store(constants.SURVEY_EXPIRATION_NAME, -1);
  } else {
    store(
      constants.SURVEY_EXPIRATION_NAME,
      new Date().getTime() + keepDays * 1000 * 60 * 60 * 24
    );
  }
};

export default declineSurvey;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/declineSurvey.js